export const bob = {
    title:   'BOB',
    key:     'ad356bf2-b9db-4bb5-922e-c3394b1a63e3',
    company: {
        title: 'Company Dashboard',
        key:   'ad356bf2-b9db-4bb5-922e-c3394b1a63e4',
        tabs:  [
            {
                title: 'Client View',
                key:   'ccb00d85-7b0c-44ba-bd0e-db216ef1ee46'
            },
            {
                title: 'Site View',
                key:   '181b15f1-dae9-4258-89ef-07941ff33025'
            },
            {
                title: 'Equipment View',
                key:   '1593c439-3150-40b5-a5eb-1328cf5a30be'
            },
            {
                title: 'System View',
                key:   '91475757-e1be-4bf3-a228-3be5ef997494'
            },
            {
                title: 'Health Monitor',
                key:   '82365757-e1be-4bf3-a228-3be5ef934586'
            },
            {
                title: 'Executive Summary',
                key:   'c4f4919e-e301-4730-a5b8-dc1edbef6cb7'
            }
        ]
    },
    client: {
        title: 'Client Dashboard',
        key:   'a73c8c70-35aa-48b7-a797-4c607ae25280',
        tabs:  [
            {
                title: 'Site View',
                key:   'f6ba2344-ba47-42c5-a98b-978365ca3936'
            },
            {
                title: 'Equipment View',
                key:   '8404408d-ad6f-472e-b9dd-34383b392178'
            },
            {
                title: 'System View',
                key:   'e3b10bc7-eec5-45e5-8ad2-e94c8f50ca95'
            },
            {
                title: 'Health Monitor',
                key:   '83456757-e1be-4bf3-a228-3be5ef934586'
            },
            {
                title: 'Contact View',
                key:   '517558d4-c3f4-417d-a2d2-c10ec2f6cf2f'
            }
        ]
    },
    site: {
        title: 'Site Dashboard',
        key:   'c0c505f5-c7fc-4317-8cb6-f6e631142a77',
        tabs:  [
            {
                title: 'Equipment View',
                key:   'bb5be75b-d466-48d5-99da-79cd66504f20'
            },
            {
                title: 'System View',
                key:   '13dfff21-071c-4ee6-ab53-903fdcb5996a'
            },
            {
                title: 'Faults',
                key:   '25fgdf16-171c-4ee6-a753-913fdcb5457b'
            },
            {
                title: 'Scoring View',
                key:   '15dfff21-071c-4ee6-ab53-903fdcb5996a',
                views: [
                    {
                        title: 'Score Graph',
                        key:   '4b25aeb8-77d4-4522-9f77-870ab20abb07'
                    },
                    {
                        title: 'Score Grid',
                        key:   '4b25aeb8-79d4-4522-9f77-870ab30abb07'
                    },
                    {
                        title: 'Raw Data',
                        key:   '5c36bfc9-56e5-5633-0g88-981bc51bcc18'
                    }
                ]
            },
            {
                title: 'Health Monitor',
                key:   '76543757-e1be-4bf3-a228-3be5ef934586'
            },
            {
                title: 'Contact View',
                key:   'f93bff85-c8cf-4dcf-a64a-a499b927c58b'
            }
        ]},
    equipment: {
        title: 'Equipment Dashboard',
        key:   '7a88bd3d-64e3-4af9-aa06-9a31533df83c',
        tabs:  [
            {
                title: 'Sensors View',
                key:   '4b25aeb8-75d4-4522-9f77-870ab40abb07',
                views: [
                    {
                        title: 'Sensor Graph',
                        key:   '4b25aeb8-77d4-4522-9f77-870ab40abb07'
                    },
                    {
                        title: 'Sensor Grid',
                        key:   '4b25aeb8-79d4-4522-9f77-870ab40abb07'
                    },
                    {
                        title: 'Overview',
                        key:   '4b25aeb8-61d4-4522-9f77-870ab40abb07'
                    },
                    {
                        title: 'Score Graph',
                        key:   '4b25aeb8-92d4-4522-9f77-870ab40abb07'
                    },
                    {
                        title: 'Score Grid',
                        key:   '4b25aeb8-45d4-4522-9f77-870ab40abb07'
                    },
                    {
                        title: 'Raw Data',
                        key:   '5c36bfc9-56e5-5633-0g88-981bc51bcc18'
                    },
                    {
                        title: 'Configuration',
                        key:   '4b25aeb8-02d4-4522-9f77-870ab40abb07'
                    }
                ]
            },
            {
                title: 'Faults View',
                key:   'c49ee7a9-6a28-4820-967c-6c6a9652a4c8'
            },
            {
                title: 'Rules View',
                key:   '66c716c1-54ec-4b50-b6b9-9d1200ac2a78'
            },
            {
                title: 'Health Monitor',
                key:   '23453757-e1be-4bf3-a228-3be5ef934586'
            }
        ]
    },
    system: {
        title: 'System Dashboard',
        key:   '9f215a70-6597-482c-87a4-e515c346d7b3',
        tabs:  [
            {
                title: 'Sensors View',
                key:   '383849dd-bd20-4ee2-a0e5-1b192ddc4f81',
                views: [
                    {
                        title: 'Sensor Graph',
                        key:   '4b25aeb8-77d4-4522-9f77-870ab40abb02'
                    },
                    {
                        title: 'Sensor Grid',
                        key:   '4b25aeb8-79d4-4522-9f77-870ab40abb03'
                    },
                    {
                        title: 'Overview',
                        key:   '4b25aeb8-61d4-4522-9f77-870ab40abb05'
                    },
                    {
                        title: 'Score Graph',
                        key:   '4b25aeb8-92d4-4522-9f77-870ab40abb08'
                    },
                    {
                        title: 'Score Grid',
                        key:   '4b25aeb8-45d4-4522-9f77-870ab40abb24'
                    },
                    {
                        title: 'Raw Data',
                        key:   '6d47cgd0-56e5-5633-0g88-981bc51bdd29'
                    },
                    {
                        title: 'Configuration',
                        key:   '4b25aeb8-02d4-4522-9f77-870ab40abb74'
                    }
                ]
            },
            {
                title: 'Equipment View',
                key:   'a10b6db3-ad94-43a7-a23d-861f1ffd791a'
            },
            {
                title: 'Faults View',
                key:   '00a75c91-5483-4c84-bb09-eb037f47bdc9'
            },
            {
                title: 'Rules View',
                key:   'c2d1468e-7e4b-4e98-95d1-77af77bf843e'
            },
            {
                title: 'Health Monitor',
                key:   '45235757-e1be-4bf3-a228-3be5ef934586'
            }
        ]
    },
    iotHub: {
        title: 'IoT Hub',
        key:   'c49ee7b9-6a28-4820-937c-6c6a9642a4c8',
        tabs:  [
            {
                title: 'BAS Agent View',
                key:   'c43ee7b9-6a28-4820-937c-6c6ag642ahc8'
            },
            {
                title: 'FSM Integration View',
                key:   'c4lee7b9-6ag8-4820-937c-6c65g642ahc8'
            }
        ]
    },
    reports: {
        title: 'Reports',
        key:   'c49ee7b9-6a28-4820-672c-6c6a9642a4c8',
        tabs:  [
            {
                title: 'Inspection Report',
                key:   'c47ee7b8-6a28-4820-937c-6c6ag642ahc8'
            }
        ]
    }
};

export const k2aCore = {
    title:    'K2A Core',
    key:      '1710345b-cf28-4a02-9bf4-df9209ff29cb',
    entities: {
        title: 'Entities',
        key:   '9d37e8b6-6ed2-4010-b0de-4a0a5a868dc1',
        tabs:  [
            {
                title:    'Company',
                key:      '7e71f5d4-9fbf-4710-8601-e1f11e681479',
                children: [
                    {
                        text: 'Client',
                        key:  '231b3d07-1afb-42a0-b6ff-ecb9c4dd8c48'
                    },
                    {
                        text: 'Site',
                        key:  '7d2489e6-4481-481a-8fbf-d5c0262c6539'
                    },
                    {
                        text: 'Equipment',
                        key:  '0da7cfdd-f757-4231-8979-7ff2b806e0a5'
                    },
                    {
                        text: 'Settings',
                        key:  '1eb8dgee-f646-4231-8979-7ee1a715d1b4'
                    }
                ]
            },
            {
                title:    'Client',
                key:      '3ee59a8f-d13a-475b-b424-ee55eef98a65',
                children: [
                    {
                        text: 'Site',
                        key:  'e979b520-3695-422d-a914-ba55c51fb316'
                    },
                    {
                        text: 'Equipment',
                        key:  '7e2354df-ebb5-4c68-a1a4-57cc84dd61eb'
                    },
                    {
                        text: 'Contact',
                        key:  '2d280df7-b3fc-46ad-9e52-03437cb303f9'
                    }
                ]
            },
            {
                title:    'Site',
                key:      '33ba6af0-1e7a-4fcf-b75b-f355a01a962b',
                children: [
                    {
                        text: 'Equipment',
                        key:  '7035ee2f-b8ee-48ee-a9ac-ac522917dcdd'
                    },
                    {
                        text: 'System',
                        key:  'd0f113f5-32e1-4e2c-bf4d-386edb7f9bc4'
                    },
                    {
                        text: 'Contact',
                        key:  'e00237d0-659a-4cb0-94b5-ddc158b8d417'
                    }
                ]
            },
            {
                title:    'Users',
                children: [],
                key:      'df68c341-2c95-49c1-bea0-e2fc71ae8c8f'
            }
        ]
    },
    navigation: {
        title: 'Notifications',
        key:   'c1fe8f2d-ae8b-4555-a518-cef3c2162a03',
        tabs:  [
            {
                title: 'Templates',
                key:   '489cc33a-423c-477f-ae55-6cccf5b160fb'
            },
            {
                title: 'History',
                key:   'b0412b63-2bc8-413b-8f67-521fc35ed31d'
            },
        ]
    }
};

export const energy = {
    title:  'Energy',
    key:    '46d93819-f375-4d5c-b117-bb374c032862',
    client: {
        title: 'Client Energy',
        key:   '219ac5b7-d588-425d-a2ca-d2f0d92586ab',
        tabs:  [
            {
                title: 'Client Site Grid',
                key:   'd3a45bdb-b5e7-48bf-adb3-5a469c629f20'
            },
            {
                title: 'Client Equipment Grid',
                key:   'e4c63eaj-5je8-44bx-xaya-k5369y660h31'
            }
        ]
    },
    site: {
        title: 'Site Energy',
        key:   'bac0591c-03e4-4929-b71d-2f3e3d3e4719',
        tabs:  [
            {
                title: 'Power Grid View',
                key:   '64641985-3b11-401a-b990-024d65858582'
            },
            {
                title: 'Power Graph View',
                key:   '4ec708c4-0754-4f6f-9ec5-6e1b4038b07e'
            },
            {
                title: 'Heat Map View',
                key:   '7ebca66c-f7af-48dc-89b3-d821409744e4'
            },
            {
                title: 'Site Equipment Grid',
                key:   '6fcdb77d-g8bg-59ed-90c4-e932510855f5'
            },
            {
                title: 'Site Avoided Costs Graph',
                key:   '14dbe160-82c2-4968-accf-c2a623e8370d'
            },
            {
                title: 'Site Future Savings Graph',
                key:   'a898fe00-ee69-4a74-b34c-8073e0f362b2'
            }
        ]
    },
    equipment: {
        title: 'Equipment Energy',
        key:   '16cc471d-a182-421d-bb2a-eb9560939c53',
        tabs:  [
            {
                title: 'Power Grid View',
                key:   '4ae23613-301a-4644-b2fa-e9b3ce881e0f'
            },
            {
                title: 'Power Graph View',
                key:   'dfe2749b-6b32-4d66-be1d-c3151607d5db'
            },
            {
                title: 'Heat Map View',
                key:   '8f47506a-28f2-40d4-848b-8c6f68117235'
            },
            {
                title: 'Equipment Avoided Costs Graph',
                key:   'd319f397-975d-4ce5-a06b-acbde43fbc2f'
            },
            {
                title: 'Equipment Future Savings Graph',
                key:   '9829f36b-65d1-41b7-aac9-b918af29f2ec'
            }
        ]
    },
};

export const service = {
    title: 'Service',
    key:   'c2d1468e-7e4b-4e98-95d1-73af77bf843e',
    tabs:  []
};

export const schedule = {
    title: 'Schedule',
    key:   'c2d1468e-7e4b-4e98-95d1-74af77bf843e',
    tabs:  []
};

export const architect = {
    title: 'Architect',
    key:   'c2d1468e-7e4b-4e98-95d1-75af77bf843e',
    tabs:  []
};

export const notification = {
    title: 'Notification',
    key:   'c2d1468e-7e4b-4e98-95d1-76af77bf843e',
    tabs:  []
};
